export const formatterMbKb = (bytes) => {

  if (!bytes) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  const totalMB = (bytes / 1048576).toFixed(2);
  return totalMB > 0 ? `${totalMB} MB` : `${totalMB * 1024} KB`;
};
